import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({
    name: 'booleanTranslator',
    pure: false
})
export class BooleanTranslatorPipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) { }

    transform(value: boolean): string {
        const currentLang = this.localizationService.getCachedLanguage();
        if (currentLang === 'ar') {
            return value ? 'نعم' : 'لا';
        }
        return value ? 'Yes' : 'No';
    }
}
